























































































































































































































































































import Vue from 'vue';
import { createNamespacedHelpers, mapState as mapRootState, mapActions as mapRootActions } from 'vuex';
import FileUpload from '../common/form/FileUpload.vue';
import TextArea from '../common/form/TextArea.vue';
import FormInput from '../common/form/FormInput.vue';
import PaginatedSingleSelect from '../common/form/PaginatedSingleSelect.vue';
import Errors from '../common/form/Errors.vue';
import Checkbox from '../common/form/Checkbox.vue';
import InputText from '../common/form/InputText.vue';
import InputDate from '../common/form/InputDate.vue';
const { mapState, mapActions, mapMutations, mapGetters } = createNamespacedHelpers('grievanceForm');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    components: { InputText, Errors, Checkbox, PaginatedSingleSelect, FormInput, TextArea, FileUpload, InputDate },
    computed: {
        ...mapCustomLabelsState(['createGrievanceText', 'grievanceDescriptionPlaceholder', 'detailsPlaceholder']),
        ...mapState([
            'info',
            'type',
            'parentCategory',
            'category',
            'description',
            'documents',
            'department',
            'customTextarea1Toggle',
            'customTextarea1',
            'customTextarea2',
            'customSingle1',
            'customSingle2',
            'projectIdMap',
            'customText1',
            'customText2',
            'eventDate',
        ]),
        ...mapRootState(['locale', 'instanceId']),
        ...mapGetters(['getFieldErrors', 'isFieldRequired', 'isFieldVisible', 'getFieldLabel']),
        categorySysFwe(): { [key: string]: { value: string } } | null {
            if (this.parentCategory?.value) {
                return { parentCategory: { value: this.parentCategory?.value } };
            }
            return null;
        },
    },
    watch: {
        parentCategory() {
            this.setCategory({ category: null });
        },
    },
    methods: {
        ...mapActions(['fetchData', 'saveDocuments']),
        ...mapMutations([
            'setDescription',
            'setType',
            'setParentCategory',
            'setCategory',
            'setDocuments',
            'removeLastUploadedDocument',
            'setIsUploading',
            'setDepartment',
            'setCustomTextarea1Toggle',
            'setCustomTextarea1',
            'setCustomTextarea2',
            'setCustomSingle1',
            'setCustomSingle2',
            'setProjectIdMap',
            'setCustomText1',
            'setCustomText2',
            'setEventDate',
        ]),
        ...mapRootActions(['addError']),
        handleError(error: Error) {
            this.addError({ error });
        },
        removeLastDocument() {
            this.setDocuments({ documents: this.documents.slice(0) });
        },
    },
});
